import { render } from "./the-header-authority-menu.vue?vue&type=template&id=626f3658&ts=true"
import script from "./the-header-authority-menu.vue?vue&type=script&lang=ts"
export * from "./the-header-authority-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__